export default __webpack_public_path__ + "static/media/GoogleIcon.0c4fe182.svg";